import React, { Fragment } from 'react';
import AboutChannel from '~/src/components/AboutChannel';
import Footer from '~/src/components/Footer';
import Header from '~/src/components/Header';
import Suspended from '~/src/components/Suspended';
import { imgHeroVideoLandscapeMp4, imgOvertimeLogoWhiteSvg } from '~/src/images';
import styles from '~/src/lib/styles.json';
import useFetch from '~/src/overtime-lib/src/www/hooks/useFetch';
import './About.scss';

type Channel = {
	id: string;
	order: number;
	name: string;
	label: string;
	logo_path: string;
	description: string;
	gradient_start_color: string;
	gradient_end_color: string;
};

const ChannelsContent = () => {
	const fetchResult = useFetch<Channel[]>({
		url: `${'https://api.itsovertime.com'}/api/channels/v1?has_page=true`,
		key: 'channels',
	});
	const channels = fetchResult.result.read();
	return (
		<Fragment>
			{channels
				.sort((a, b) => a.order - b.order)
				.map((channel) => (
					<AboutChannel channel={channel} key={channel.name} />
				))}
		</Fragment>
	);
};
function Channels() {
	return (
		<div className="channels">
			<h2>Our Channels</h2>
			<Suspended>
				<ChannelsContent />
			</Suspended>
		</div>
	);
}

export default function About() {
	return (
		<Fragment>
			<Header sticky={true} />
			<div className="About content">
				<div
					className={'hero'}
					style={{
						gridColumn: 'full',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						color: `${styles.COLOR.OFFWHITE}`,
						textAlign: 'center',
						width: '100vw',
						height: 'calc(9 / 16 * 100vw)',
						overflow: 'hidden',
					}}
				>
					<video
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							objectFit: 'cover',
						}}
						ref={(ref) => (ref ? (ref.playbackRate = 0.75) : null)}
						autoPlay
						muted
						src={imgHeroVideoLandscapeMp4}
						loop
					/>
					<div
						className={'heroCopy'}
						style={{
							zIndex: 1,
						}}
					>
						<h1
							style={{
								fontSize: '32px',
								fontFamily: styles.FONT.BRAND,
								textTransform: 'uppercase',
								margin: styles.SIZE.GAP,
							}}
						>
							About
						</h1>
						<div
							style={{
								margin: styles.SIZE.GAP,
								lineHeight: '1.5',
								fontSize: '14px',
							}}
						>
							Overtime builds disruptive new sports leagues aimed globally at the next generation of sports fans and
							athletes.
						</div>
						<img
							className="desktop-only"
							style={{
								display: 'block',
								height: '400px',
								gridColumn: 2,
								gridRow: '1 / span 2',
								justifySelf: 'end',
							}}
							src={imgOvertimeLogoWhiteSvg}
						/>
					</div>
				</div>
				<div
					className={'statsContainer'}
					style={{
						gridColumn: 'full',
						background: styles.COLOR.BRAND_PRIMARY,
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						width: '100%',
					}}
				>
					<div
						className={'stats'}
						style={{
							display: 'grid',
							gridTemplateColumns: '1fr',
							gridGap: styles.SIZE.GAP,
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<div>
							<h3>
								<span className="one">3</span>B+
							</h3>
							views per month
						</div>
						<div>
							<h3>
								<span className="one"></span>100M+
							</h3>
							followers across 7 platforms
						</div>
						<div>
							<h3>81%</h3> of our audience is under 35 years old
						</div>
						<div>
							<h3>
								<span className="one">3</span>00+
							</h3>
							full time employees
						</div>
					</div>
				</div>
				<div
					className={'copy'}
					style={{
						gridColumn: 'content',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						paddingBottom: styles.SIZE.GAP_2X,
					}}
				>
					<Channels />
					<div>
						<h2>About Overtime</h2>
						<p>
							Overtime builds disruptive new sports leagues and IP aimed globally at the next generation of sports fans
							and athletes. Overtime owns and operates, OTE and OT Select in basketball, OT7 in football and OTX in
							boxing, and leverages digital-first content across its network of accounts engaging its community of
							nearly 100 million fans and followers. Overtime's business model is driven by sponsorships, brand
							relationships, e-commerce, licensing and media rights.
						</p>
						<p>
							Overtime is funded by top VC firms, industry leaders, and athletes, including Liberty Media Corporation,
							Andreessen Horowitz, Counterpoint Global (Morgan Stanley), Sapphire Sport, Winslow Capital, Bezos
							Expeditions, Spark Capital, Micromanagement Ventures (the family of the late David Stern), Black Capital,
							Blackstone Strategic Partners, Alexis Ohanian, Drake, Quavo and 40+ NBA and NFL stars including Carmelo
							Anthony, Kevin Durant and Trae Young. Over 6% of active NBA players have invested in Overtime.{' '}
						</p>
					</div>
					<div>
						<h2>Contact Us</h2>
						<p>
							Got a question for us? Want to make a content suggestion or send us some love?{' '}
							<a
								style={{
									color: styles.COLOR.BRAND_LINK,
									textDecoration: 'none',
								}}
								href="/contact"
							>
								Get in touch with us
							</a>
							.
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	);
}
